import Icon from "./IconBase.js";
import PropTypes from "prop-types";

const ThumbsDownIcon = ({ color = "#757575", ...props }) => {
  return (
    <Icon
      width="22"
      height="20"
      viewBox="0 0 22 20"
      style={{ borderColor: "black" }}
      {...props}
    >
      <svg
        width="22"
        height="20"
        viewBox="0 0 22 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.7708 13.4887C20.5597 13.7281 20.3 13.9197 20.009 14.051C19.7181 14.1822 19.4025 14.2501 19.0833 14.25H13.8333V15.75C13.8333 16.7446 13.4383 17.6984 12.735 18.4017C12.0317 19.1049 11.0779 19.5 10.0833 19.5C9.94401 19.5001 9.8074 19.4614 9.68884 19.3882C9.57028 19.315 9.47445 19.2102 9.41209 19.0856L5.87022 12H1.83334C1.43552 12 1.05399 11.842 0.772683 11.5607C0.491379 11.2794 0.333344 10.8978 0.333344 10.5V2.25C0.333344 1.85217 0.491379 1.47064 0.772683 1.18934C1.05399 0.908035 1.43552 0.75 1.83334 0.75H17.9583C18.5065 0.749811 19.0359 0.949741 19.4471 1.31224C19.8582 1.67475 20.1229 2.17489 20.1915 2.71875L21.3165 11.7188C21.3563 12.0356 21.3283 12.3573 21.2342 12.6625C21.1402 12.9677 20.9822 13.2493 20.7708 13.4887ZM1.83334 10.5H5.58334V2.25H1.83334V10.5ZM19.8277 11.9062L18.7027 2.90625C18.6799 2.72496 18.5916 2.55825 18.4546 2.43741C18.3175 2.31658 18.1411 2.24994 17.9583 2.25H7.08334V11.0728L10.5249 17.9569C11.035 17.8548 11.4939 17.5791 11.8237 17.1767C12.1534 16.7744 12.3335 16.2702 12.3333 15.75V13.5C12.3333 13.3011 12.4124 13.1103 12.553 12.9697C12.6937 12.829 12.8844 12.75 13.0833 12.75H19.0833C19.1898 12.75 19.295 12.7274 19.392 12.6837C19.489 12.6399 19.5756 12.576 19.646 12.4962C19.7164 12.4164 19.769 12.3225 19.8004 12.2208C19.8317 12.1191 19.841 12.0118 19.8277 11.9062Z"
          fill={color}
        />
      </svg>
    </Icon>
  );
};
ThumbsDownIcon.propTypes = {
  color: PropTypes.string,
};
export default ThumbsDownIcon;
